import components from "./components";
import palette from "./palettes/primary";
import shadows from "./shadows";
import typography from "./typography";

const theme = {
  palette,
  components,
  typography,
  shadows,
};

export default theme;
